import React, { useContext, useState, useEffect } from 'react';
import { H4 } from '../../components/Typography/styles';
import {
  SurveyListContainer,
  SurveyListContent,
  SurveyListHeader,
  SurveyListHeaderTitle,
  SurveyListHeaderGrid,
  SurveyListEmptyStateContainer,
  SurveyListEmptyStateParagraph,
  SurveyButton
} from './styles';
import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';
import Loader from '../../components/Loader';
import emptyState from '../../assets/images/empty.svg';
import { useHistory } from 'react-router';
import ModalAction from '../../components/ModalAction';
import { getActiveQuestions, getAllQuestions, createQuestion } from '../../services/survey';
import redirectToCorrectPageSurvey from '../../services/redirectToCorrectPageSurvey';
import InputDefault from '../../components/InputDefault';
import { DefaultLargeButton, DefaultSmallButton} from '../../components/Buttons/styles';


const SurveyList = ({titulo, descripcion}) => {
  const [showScroll, setShowScroll] = useState(false);
  const [orderByCurrent, setOrderByCurrent] = useState(true);
  const [fadeToggle, setFadeToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [solicitationsData, setSolicitationsData] = useState([]);
  
  const history = useHistory();
  
  async function initializeStateCertifications() {
    try {
      const surveyList = await getAllQuestions();
      
      
      await setSolicitationsData(surveyList.data);
      console.log(surveyList.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }
  function crearPregunta()
  {
    const p = document.getElementById('pregunta').value;
    const m = document.getElementById('max-pregunta').value;
    const min = document.getElementById('min-pregunta').value;
    if (p && m && min && (parseInt(m) > parseInt(min)))
    {
      createQuestion({pregunta: p, activo: true, valorMaximo: m, valorMinimo: min});
      document.getElementById('pregunta').value = "";
    }
  }
  useEffect(()=> {
    initializeStateCertifications();
  }, []);
  
  return (
    <SurveyListContainer id="cdt-page">
    <SurveyListContent>
    <SurveyListHeader>
    <SurveyListHeaderTitle>{titulo}</SurveyListHeaderTitle>
    <SurveyListHeaderGrid>
    <H4 color={colors.textPrimary}>{descripcion}</H4>
    </SurveyListHeaderGrid>
    <SurveyListHeaderGrid>
    <InputDefault
      name="pregunta"
      label="Pregunta nueva"
      id="pregunta"
      />
    <InputDefault 
      type="number" 
      name="min-pregunta" 
      label="Valor min. Respuesta" 
      id="min-pregunta" 
      value="0"/>
    <InputDefault 
      type="number" 
      name="max-pregunta" 
      label="Valor max. Respuesta" 
      id="max-pregunta" 
      value="10"/>
    <DefaultSmallButton type='button' onClick={() => crearPregunta()} id='button-crear'>Crear Pregunta</DefaultSmallButton>
    </SurveyListHeaderGrid>
    </SurveyListHeader>
    {!solicitationsData.length ? (
      <SurveyListEmptyStateContainer>
      <img src={emptyState} alt="Empty state" />
      <SurveyListEmptyStateParagraph>
      No hay información para visualizar
      </SurveyListEmptyStateParagraph>
      </SurveyListEmptyStateContainer>
      ) : ''}
      {
        solicitationsData.map((item, key) => (<div>
        <SurveyButton onClick={() =>redirectToCorrectPageSurvey(history, item)} key={key}>{item.pregunta + ' - ' + (item.activo? 'activo': 'inactivo')}</SurveyButton><br/>
        </div>))
      }
      {isLoading && <Loader />}
      </SurveyListContent>
      <Copyright />
      </SurveyListContainer>
      )
    }
    
    export default SurveyList;
    
